import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import React from "react";
import Modal from "../../components/Modal";
import NoticesPairEklokContainer from "../../containers/ekloks/NoticesPairEklokContainer";
import PairEklokContainer from "../../containers/ekloks/PairEklokContainer";
import PairEklokForm from "../../forms/eklok/PairEklokForm";

const Pair = ({ handleClose, open, notices, setNotices }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      maxWidth="lg"
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={notices ? "" : "Pair Eklok"}
    >
      {notices ? (
        <NoticesPairEklokContainer
          setNotices={setNotices}
        ></NoticesPairEklokContainer>
      ) : (
        <PairEklokContainer>
          {({ onSubmit, initialValues }) => (
            <PairEklokForm onSubmit={onSubmit} initialValues={initialValues} />
          )}
        </PairEklokContainer>
      )}
    </Modal>
  );
};

export default Pair;
